(() => {
  const selectors = '[data-cc-qty-breaks] [data-qty]';

  function setQuantity(button) {
    const qty = button.getAttribute('data-qty');
    const productInfo = button.closest('product-info') || document;
    const input = productInfo.querySelector('input[name="quantity"]');

    if (!input || !qty) return;

    input.value = qty;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    button.closest('[data-cc-qty-breaks]')?.querySelectorAll('[data-qty]').forEach((item) => {
      item.classList.toggle('is-active', item === button);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(selectors);
    if (!button) return;
    event.preventDefault();
    setQuantity(button);
  });
})();

(() => {
  const gallerySelector = '[data-cc-product-gallery]';
  const colorMap = {
    orange: 'orange',
    white: 'white',
    blue: 'blue',
    navy: 'blue',
    'orange-navy': 'blue',
    'orange/navy': 'blue',
    'orange navy': 'blue',
  };

  function normalizeColor(value) {
    if (!value) return 'orange';
    const normalized = String(value).trim().toLowerCase();
    return colorMap[normalized] || colorMap[normalized.replace(/\s*\/\s*/g, '/')] || normalized.replace(/\s+/g, '-');
  }

  function setMainImage(gallery, thumb) {
    const main = gallery.querySelector('[data-cc-gallery-main]');
    if (!main || !thumb) return;

    const nextImage = thumb.getAttribute('data-image');
    const nextAlt = thumb.getAttribute('data-alt') || '';
    if (!nextImage) return;

    main.src = nextImage;
    main.alt = nextAlt;

    gallery.querySelectorAll('[data-cc-gallery-thumb]').forEach((item) => {
      item.classList.toggle('is-active', item === thumb);
      item.setAttribute('aria-current', item === thumb ? 'true' : 'false');
    });
  }

  function setGalleryColor(gallery, color) {
    const selectedColor = normalizeColor(color);
    const thumbs = Array.from(gallery.querySelectorAll('[data-cc-gallery-thumb]'));
    const matchingThumbs = thumbs.filter((thumb) => thumb.getAttribute('data-color') === selectedColor);
    const fallbackThumbs = thumbs.filter((thumb) => thumb.getAttribute('data-color') === 'orange');
    const visibleThumbs = matchingThumbs.length ? matchingThumbs : fallbackThumbs;

    thumbs.forEach((thumb) => {
      thumb.hidden = !visibleThumbs.includes(thumb);
      thumb.classList.remove('is-active');
      thumb.removeAttribute('aria-current');
    });

    setMainImage(gallery, visibleThumbs[0]);

    const rail = gallery.querySelector('.cc-product-gallery__thumbs');
    if (rail) rail.scrollTo({ left: 0, behavior: 'smooth' });
  }

  function getSelectedColorFromPicker() {
    const colorInput = document.querySelector('fieldset.product-form__input input[name^="Color"]:checked');
    if (colorInput) return colorInput.value;

    const colorSelect = document.querySelector('.product-form__input select[name="options[Color]"]');
    if (colorSelect) return colorSelect.value;

    return null;
  }

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-cc-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest(gallerySelector);
    if (!gallery) return;

    event.preventDefault();
    setMainImage(gallery, thumb);
  });

  document.addEventListener('change', (event) => {
    if (!event.target.closest('variant-selects')) return;

    const color = getSelectedColorFromPicker();
    if (!color) return;

    document.querySelectorAll(gallerySelector).forEach((gallery) => setGalleryColor(gallery, color));
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const color = data?.variant?.options?.[0] || getSelectedColorFromPicker();
      document.querySelectorAll(gallerySelector).forEach((gallery) => setGalleryColor(gallery, color));
    });
  }

  document.querySelectorAll(gallerySelector).forEach((gallery) => {
    setGalleryColor(gallery, gallery.getAttribute('data-initial-color'));
  });
})();
